import React from 'react';

const ClickGraphicSvg = (props) => (
    <svg viewBox="0 0 144 144" {...props}>
        <defs>
            <path id="click-graphic_svg__a" d="M0 94.918h55.173V0H0z" />
            <path id="click-graphic_svg__c" d="M0 94.918h55.173V0H0z" />
            <path id="click-graphic_svg__e" d="M0 94.918h55.173V0H0z" />
            <path id="click-graphic_svg__g" d="M0 94.918h55.173V0H0z" />
            <path id="click-graphic_svg__i" d="M0 94.918h55.173V0H0z" />
            <path id="click-graphic_svg__k" d="M0 94.918h55.173V0H0z" />
            <path id="click-graphic_svg__m" d="M0 94.918h55.173V0H0z" />
            <path id="click-graphic_svg__o" d="M0 94.918h55.173V0H0z" />
            <path id="click-graphic_svg__q" d="M0 94.918h55.173V0H0z" />
            <path id="click-graphic_svg__s" d="M0 94.918h55.173V0H0z" />
            <path id="click-graphic_svg__u" d="M0 94.918h55.173V0H0z" />
            <path id="click-graphic_svg__w" d="M0 94.918h55.173V0H0z" />
            <path id="click-graphic_svg__y" d="M0 94.918h55.173V0H0z" />
        </defs>
        <g fill="none" fillRule="evenodd">
            <path
                d="M83.033 47.247c0 9.009-7.393 16.313-16.513 16.313-9.12 0-16.515-7.304-16.515-16.313 0-9.011 7.395-16.314 16.515-16.314 9.12 0 16.513 7.303 16.513 16.314"
                fill="#F05537"
                fillRule="nonzero"
            />
            <path
                d="M65.018 105.086c0-2.964-9.007-13.347-9.007-13.347l-9.008-22.246c0-2.457 2.018-4.45 4.503-4.45 3.004 0 4.505 2.966 4.505 2.966l6.005 11.865V48.73c0-2.457 2.018-4.45 4.503-4.45 2.487 0 4.505 1.993 4.505 4.45v16.313c0-2.455 2.017-4.448 4.503-4.448 2.487 0 4.504 1.993 4.504 4.448v2.966c0-2.455 2.016-4.448 4.503-4.448 2.488 0 4.504 1.993 4.504 4.448v2.967c0-2.456 2.019-4.449 4.504-4.449 2.487 0 4.505 1.993 4.505 4.449v10.382c0 10.381-6.005 16.314-6.005 19.28v4.448"
                fill="#F8FAFF"
                fillRule="nonzero"
            />
            <g transform="translate(44 25)">
                <mask id="click-graphic_svg__b" fill="#fff">
                    <use xlinkHref="#click-graphic_svg__a" />
                </mask>
                <path
                    fill="#DBDAE3"
                    fillRule="nonzero"
                    mask="url(#click-graphic_svg__b)"
                    d="M18.016 94.918h33.028V80.087H18.016z"
                />
            </g>
            <g transform="translate(44 25)">
                <mask id="click-graphic_svg__d" fill="#fff">
                    <use xlinkHref="#click-graphic_svg__c" />
                </mask>
                <path
                    fill="#1E0A3C"
                    fillRule="nonzero"
                    mask="url(#click-graphic_svg__d)"
                    d="M52.17 94.918h-2.252v-13.72H19.14v13.72h-2.252V78.974h35.28z"
                />
            </g>
            <g transform="translate(44 25)">
                <mask id="click-graphic_svg__f" fill="#fff">
                    <use xlinkHref="#click-graphic_svg__e" />
                </mask>
                <path
                    fill="#1E0A3C"
                    fillRule="nonzero"
                    mask="url(#click-graphic_svg__f)"
                    d="M43.537 87.132h3.002v-2.224h-3.002z"
                />
            </g>
            <g transform="translate(44 25)">
                <mask id="click-graphic_svg__h" fill="#fff">
                    <use xlinkHref="#click-graphic_svg__g" />
                </mask>
                <path
                    fill="#1E0A3C"
                    fillRule="nonzero"
                    mask="url(#click-graphic_svg__h)"
                    d="M37.532 87.132h3.002v-2.224h-3.002z"
                />
            </g>
            <g transform="translate(44 25)">
                <mask id="click-graphic_svg__j" fill="#fff">
                    <use xlinkHref="#click-graphic_svg__i" />
                </mask>
                <path
                    d="M49.167 80.086h-2.251v-4.448c0-1.303.756-2.75 1.803-4.751 1.773-3.391 4.202-8.035 4.202-14.529V45.976c0-1.84-1.517-3.338-3.378-3.338-1.863 0-3.378 1.497-3.378 3.338h-2.252v-2.967c0-1.838-1.515-3.335-3.378-3.335-1.863 0-3.378 1.497-3.378 3.335h-2.252v-2.966c0-1.84-1.515-3.337-3.378-3.337-1.862 0-3.378 1.497-3.378 3.337h-2.251V23.73c0-1.84-1.516-3.338-3.378-3.338-1.863 0-3.379 1.497-3.379 3.338v35.855l-8.138-16.078c-.01-.02-1.245-2.351-3.496-2.351-1.796 0-3.266 1.39-3.372 3.137l8.851 21.862c1.794 2.076 9.158 10.794 9.158 13.931h-2.251c0-1.596-4.443-7.673-8.738-12.623l-.19-.31-9.088-22.66c0-3.067 2.525-5.561 5.63-5.561 3.656 0 5.437 3.435 5.51 3.581l3.873 7.65V23.73c0-3.068 2.525-5.562 5.63-5.562 3.104 0 5.63 2.494 5.63 5.562v11.868a5.649 5.649 0 0 1 3.377-1.116c2.634 0 4.85 1.794 5.462 4.21a5.648 5.648 0 0 1 3.546-1.244c2.632 0 4.849 1.795 5.462 4.21a5.645 5.645 0 0 1 3.546-1.244c3.103 0 5.63 2.494 5.63 5.562v10.382c0 7.036-2.68 12.16-4.454 15.549-.832 1.593-1.552 2.968-1.552 3.73v4.45z"
                    fill="#1E0A3C"
                    fillRule="nonzero"
                    mask="url(#click-graphic_svg__j)"
                />
            </g>
            <g transform="translate(44 25)">
                <mask id="click-graphic_svg__l" fill="#fff">
                    <use xlinkHref="#click-graphic_svg__k" />
                </mask>
                <path
                    fill="#363A43"
                    fillRule="nonzero"
                    mask="url(#click-graphic_svg__l)"
                    d="M43.912 48.942h2.252v-4.448h-2.252z"
                />
            </g>
            <g transform="translate(44 25)">
                <mask id="click-graphic_svg__n" fill="#fff">
                    <use xlinkHref="#click-graphic_svg__m" />
                </mask>
                <path
                    fill="#363A43"
                    fillRule="nonzero"
                    mask="url(#click-graphic_svg__n)"
                    d="M34.906 47.458h2.252V43.01h-2.252z"
                />
            </g>
            <g transform="translate(44 25)">
                <mask id="click-graphic_svg__p" fill="#fff">
                    <use xlinkHref="#click-graphic_svg__o" />
                </mask>
                <path
                    fill="#363A43"
                    fillRule="nonzero"
                    mask="url(#click-graphic_svg__p)"
                    d="M25.897 45.976h2.251v-5.932h-2.251z"
                />
            </g>
            <g transform="translate(44 25)">
                <mask id="click-graphic_svg__r" fill="#fff">
                    <use xlinkHref="#click-graphic_svg__q" />
                </mask>
                <path
                    fill="#1E0A3C"
                    fillRule="nonzero"
                    mask="url(#click-graphic_svg__r)"
                    d="M21.394 11.865h2.251V0h-2.251z"
                />
            </g>
            <g transform="translate(44 25)">
                <mask id="click-graphic_svg__t" fill="#fff">
                    <use xlinkHref="#click-graphic_svg__s" />
                </mask>
                <path
                    fill="#1E0A3C"
                    fillRule="nonzero"
                    mask="url(#click-graphic_svg__t)"
                    d="M30.822 15.617l-1.593-1.573 9.008-8.899L39.83 6.72z"
                />
            </g>
            <g transform="translate(44 25)">
                <mask id="click-graphic_svg__v" fill="#fff">
                    <use xlinkHref="#click-graphic_svg__u" />
                </mask>
                <path
                    fill="#1E0A3C"
                    fillRule="nonzero"
                    mask="url(#click-graphic_svg__v)"
                    d="M14.217 15.617L5.21 6.72l1.593-1.574 9.008 8.899z"
                />
            </g>
            <g transform="translate(44 25)">
                <mask id="click-graphic_svg__x" fill="#fff">
                    <use xlinkHref="#click-graphic_svg__w" />
                </mask>
                <path
                    fill="#1E0A3C"
                    fillRule="nonzero"
                    mask="url(#click-graphic_svg__x)"
                    d="M33.028 23.36h12.01v-2.225h-12.01z"
                />
            </g>
            <g transform="translate(44 25)">
                <mask id="click-graphic_svg__z" fill="#fff">
                    <use xlinkHref="#click-graphic_svg__y" />
                </mask>
                <path
                    fill="#1E0A3C"
                    fillRule="nonzero"
                    mask="url(#click-graphic_svg__z)"
                    d="M0 23.36h12.01v-2.225H0z"
                />
            </g>
        </g>
    </svg>
);

ClickGraphicSvg.displayName = 'ClickGraphicSvg';
export default ClickGraphicSvg;
